import { IsBoolean } from 'class-validator';

export class PublicProfileHighlightedUpdateManagementModel {
  @IsBoolean()
  public highlighted: boolean;

  constructor(
    highlighted: boolean
  ) {
    this.highlighted = highlighted;
  }
}
